import type { StaticTextLookupKey, StaticTextLookup } from 'src/translators/static-text-lookup';
import { staticTextLookup as deDeStaticTextLookup } from 'src/translators/static-text/de-de';
import { staticTextLookup as enGbStaticTextLookup } from 'src/translators/static-text/en-gb';
import { staticTextLookup as esEsStaticTextLookup } from 'src/translators/static-text/es-es';
import { staticTextLookup as caEsStaticTextLookup } from 'src/translators/static-text/ca-es';
import { staticTextLookup as itItStaticTextLookup } from 'src/translators/static-text/it-it';
import { staticTextLookup as frBeStaticTextLookup } from 'src/translators/static-text/fr-be';
import { staticTextLookup as nlBeStaticTextLookup } from 'src/translators/static-text/nl-be';
import { Language } from 'src/shared/enums/language';

export const staticTextLookupByLanguage = {
  [Language.EN_GB]: enGbStaticTextLookup,
  [Language.ES_ES]: esEsStaticTextLookup,
  [Language.CA_ES]: caEsStaticTextLookup,
  [Language.NL_BE]: nlBeStaticTextLookup,
  [Language.FR_BE]: frBeStaticTextLookup,
  [Language.IT_IT]: itItStaticTextLookup,
  [Language.DE_DE]: deDeStaticTextLookup,
};

const fallbackLanguage: Language = Language.EN_GB;
const fallbackStaticTextLookup: StaticTextLookup = staticTextLookupByLanguage[fallbackLanguage];

export const translateStaticTextIntoLanguage = (
  key: StaticTextLookupKey,
  language: Language = fallbackLanguage
): string => {
  const textInCurrentLanguage = staticTextLookupByLanguage[language][key];

  if (textInCurrentLanguage) {
    return textInCurrentLanguage;
  }

  console.warn(`No translation found for ${key} in the languge ${language}`);

  return fallbackStaticTextLookup[key];
};
